import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import '@sistemiv/s-components/dist/TC.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import LoadingLogo from './assets/loading_logo.png'
import './services/i18n'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.Suspense
    fallback={
      <div className='w-screen h-screen flex items-center justify-center'>
        <img src={LoadingLogo} />
      </div>
    }
  >
    <App />
  </React.Suspense>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
